/**
  * @function evalute - evaluate pipeBendOptionsBehavior
  */

const evaluate = async (source, content) => {
  const {
    identifier = '?',
    bends = {}
  } = content;
  const result = {};
  const keys = Object.keys(bends);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const {
      _created,
      bendType = {
        any: {}
      },
      angle = '?'
    } = bends[key];
    const [{
      title = '?'
    }] = Object.values(bendType);
    result[key] = {
      _created,
      title: `${identifier}-${title}-${angle}`
    };
  }
  return result;
};
module.exports = {
  evaluate
};